function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: #7b9eb0 } \n\t\t.shp1 { fill: #ffffff } \n\t");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile"
}, /*#__PURE__*/React.createElement("g", {
  id: "Home"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9"
}, /*#__PURE__*/React.createElement("g", {
  id: "map-(1)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  className: "shp0",
  d: "M23.9 24.04L14 34L4.1 24.04C-1.37 18.55 -1.37 9.61 4.1 4.12C9.56 -1.37 18.44 -1.37 23.9 4.12C29.37 9.61 29.37 18.55 23.9 24.04ZM14 22.19C18.45 22.19 22.06 18.55 22.06 14.08C22.06 9.61 18.45 5.97 14 5.97C9.55 5.97 5.94 9.61 5.94 14.08C5.94 18.55 9.55 22.19 14 22.19Z"
})), /*#__PURE__*/React.createElement("path", {
  id: "Oval",
  className: "shp0",
  d: "M24.16 18.21C21.83 23.83 15.41 26.49 9.79 24.16C4.17 21.83 1.51 15.41 3.84 9.79C6.17 4.17 12.59 1.51 18.21 3.84C23.83 6.17 26.49 12.59 24.16 18.21Z"
})), /*#__PURE__*/React.createElement("g", {
  id: "front-store"
}, /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  fillRule: "evenodd",
  className: "shp1",
  d: "M20.22 9.5L7.78 9.5L7.78 8L20.22 8L20.22 9.5ZM20.22 15.5L20.22 20L18.67 20L18.67 15.5L15.56 15.5L15.56 20L7.78 20L7.78 15.5L7 15.5L7 14L7.78 10.25L20.22 10.25L21 14L21 15.5L20.22 15.5ZM14 15.5L9.33 15.5L9.33 18.5L14 18.5L14 15.5Z"
})))));

var SvgPdvi = function SvgPdvi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 34",
    width: 28,
    height: 34,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPdvi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pdvi.56ef6807.svg";
export { ForwardRef as ReactComponent };